import { type KibigValidationFlags } from "@/types"
import { type Configuration } from "@/graphql/types"
import { type MappedConfiguration } from "@/store/configuration"

export function resetValidationFlags(): KibigValidationFlags {
  return {
    hasEmpty: false,
    hasDuplicate: false,
    hasGeneratedDuplicate: false,
    hasGeneratedEmpty: false,
  }
}

export function computeKibigValidation(
  configMuster: boolean,
  check: { hasEmpty: boolean; hasDuplicate: boolean }
) {
  return {
    hasEmpty: configMuster ? false : check.hasEmpty,
    hasDuplicate: configMuster ? false : check.hasDuplicate,
    hasGeneratedDuplicate: configMuster ? check.hasDuplicate : false,
    hasGeneratedEmpty: configMuster ? check.hasEmpty : false,
  }
}

export const flatten = (config?: Configuration): MappedConfiguration | undefined => {
  if (!config) return undefined

  return {
    ...config.values,
    level: config.level,
  }
}
